/* eslint-disable max-len */
import React from "react";
import {AppRoute} from "./enum";
import AppRouteInfo from "./info";
import {addRouteComponent} from "../helpers/addRouteComponent";
import {Switch} from "react-router-dom";
import {Routes} from "../helpers/Routes";
import {getWrapper} from "./wrapper";

function getAppComponent(routeId) {
    switch (routeId) {
        case AppRoute.Root:
            return () => import("../../containers/AppPage");
        case AppRoute.Dashboard:
            return () => import("../../containers/AppPage/Dashboard");
        case AppRoute.Dashboard2:
            return () => import("../../containers/AppPage/Dashboard2");
        case AppRoute.BukkuAI:
            return () => import("../../containers/AppPage/AI");
        case AppRoute.Financing:
            return () => import("../../containers/AppPage/Financing");
        case AppRoute.Sales:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.SalesQuotations:
            return () => import("../../containers/AppPage/Sales/Quotes");
        case AppRoute.SalesQuotationsNew:
            return () => import("../../containers/AppPage/Sales/Quotes/new");
        case AppRoute.SalesQuotationsBatch:
            return () => import("../../containers/AppPage/Sales/Quotes/BatchQuotation");
        case AppRoute.SalesQuotationsView:
            return () => import("../../containers/AppPage/Sales/Quotes/view");
        case AppRoute.SalesOrders:
            return () => import("../../containers/AppPage/Sales/Orders");
        case AppRoute.SalesOrdersNew:
            return () => import("../../containers/AppPage/Sales/Orders/new");
        case AppRoute.SalesOrdersBatch:
            return () => import("../../containers/AppPage/Sales/Orders/BatchOrders");
        case AppRoute.SalesOrdersView:
            return () => import("../../containers/AppPage/Sales/Orders/view");
        case AppRoute.SalesDeliveryOrders:
            return () => import("../../containers/AppPage/Sales/DeliveryOrders");
        case AppRoute.SalesDeliveryOrdersNew:
            return () => import("../../containers/AppPage/Sales/DeliveryOrders/new");
        case AppRoute.SalesDeliveryOrdersView:
            return () => import("../../containers/AppPage/Sales/DeliveryOrders/view");
        case AppRoute.SalesDeliveryOrdersBatch:
            return () => import("../../containers/AppPage/Sales/DeliveryOrders/BatchDeliveryOrders");
        case AppRoute.SalesInvoices:
            return () => import("../../containers/AppPage/Sales/Invoices");
        case AppRoute.SalesInvoicesNew:
            return () => import("../../containers/AppPage/Sales/Invoices/new");
        case AppRoute.SalesInvoicesBatch:
            return () => import("../../containers/AppPage/Sales/Invoices/BatchInvoices");
        case AppRoute.SalesInvoicesBatchCash:
            return () => import("../../containers/AppPage/Sales/Invoices/BatchCashInvoices");
        // case AppRoute.SalesInvoicesView:
        //     return () => import("../../containers/AppPage/Sales/Invoices/view_deprecated");
        case AppRoute.SalesInvoicesView:
            return () => import("../../containers/AppPage/Sales/Invoices/view");
        case AppRoute.SalesCreditNotes:
            return () => import("../../containers/AppPage/Sales/CreditNotes");
        case AppRoute.SalesCreditNotesNew:
            return () => import("../../containers/AppPage/Sales/CreditNotes/new");
        case AppRoute.SalesCreditNotesBatch:
            return () => import("../../containers/AppPage/Sales/CreditNotes/BatchCreditNote");
        case AppRoute.SalesCreditNotesView:
            return () => import("../../containers/AppPage/Sales/CreditNotes/view");
        case AppRoute.SalesPayments:
            return () => import("../../containers/AppPage/Sales/Payments");
        case AppRoute.SalesPaymentsNew:
            return () => import("../../containers/AppPage/Sales/Payments/new");
        case AppRoute.SalesPaymentsModeView:
            return () => import("../../containers/AppPage/Sales/Payments/new");
        case AppRoute.SalesPaymentsBatch:
            return () => import("../../containers/AppPage/Sales/Payments/BatchPayments");
        case AppRoute.SalesPaymentsView:
            return () => import("../../containers/AppPage/Sales/Payments/view");
        case AppRoute.SalesRefunds:
            return () => import("../../containers/AppPage/Sales/Refunds");
        case AppRoute.SalesRefundsNew:
            return () => import("../../containers/AppPage/Sales/Refunds/new");
        case AppRoute.SalesRefundsBatch:
            return () => import("../../containers/AppPage/Sales/Refunds/BatchRefunds");
        case AppRoute.SalesRefundsView:
            return () => import("../../containers/AppPage/Sales/Refunds/view");
        case AppRoute.SalesOpeningInvoicesView:
            return () => import("../../containers/AppPage/Sales/OpeningInvoices/view");
        case AppRoute.SalesOpeningCreditNotesView:
            return () => import("../../containers/AppPage/Sales/OpeningCreditNotes/view");
        case AppRoute.Purchases:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.PurchasesOrders:
            return () => import("../../containers/AppPage/Purchases/Orders");
        case AppRoute.PurchasesOrdersNew:
            return () => import("../../containers/AppPage/Purchases/Orders/new");
        case AppRoute.PurchasesOrdersBatch:
            return () => import("../../containers/AppPage/Purchases/Orders/BatchPurchaseOrder");
        case AppRoute.PurchasesOrdersView:
            return () => import("../../containers/AppPage/Purchases/Orders/view");
        case AppRoute.PurchasesGoodsReceivedNotes:
            return () => import("../../containers/AppPage/Purchases/GoodsReceivedNotes");
        case AppRoute.PurchasesGoodsReceivedNotesNew:
            return () => import("../../containers/AppPage/Purchases/GoodsReceivedNotes/new");
        case AppRoute.PurchasesGoodsReceivedNotesView:
            return () => import("../../containers/AppPage/Purchases/GoodsReceivedNotes/view");
        case AppRoute.PurchasesBills:
            return () => import("../../containers/AppPage/Purchases/Bills");
        case AppRoute.PurchasesBillsNew:
            return () => import("../../containers/AppPage/Purchases/Bills/new");
        case AppRoute.PurchasesBillsBatch:
            return () => import("../../containers/AppPage/Purchases/Bills/BatchBills");
        case AppRoute.PurchasesBillsBatchCash:
            return () => import("../../containers/AppPage/Purchases/Bills/BatchCashBills");
        case AppRoute.PurchasesBillsBatchExpenseClaims:
            return () => import("../../containers/AppPage/Purchases/Bills/BatchExpenseClaims");
        case AppRoute.PurchasesBillsView:
            return () => import("../../containers/AppPage/Purchases/Bills/view");
        case AppRoute.PurchasesCreditNotes:
            return () => import("../../containers/AppPage/Purchases/CreditNotes");
        case AppRoute.PurchasesCreditNotesNew:
            return () => import("../../containers/AppPage/Purchases/CreditNotes/new");
        case AppRoute.PurchasesCreditNotesBatch:
            return () => import("../../containers/AppPage/Purchases/CreditNotes/BatchPurchaseCreditNotes");
        case AppRoute.PurchasesCreditNotesView:
            return () => import("../../containers/AppPage/Purchases/CreditNotes/view");
        case AppRoute.PurchasesPayments:
            return () => import("../../containers/AppPage/Purchases/Payments");
        case AppRoute.PurchasesPaymentsNew:
            return () => import("../../containers/AppPage/Purchases/Payments/new");
        case AppRoute.PurchasesPaymentsBatch:
            return () => import("../../containers/AppPage/Purchases/Payments/BatchPayments");
        case AppRoute.PurchasesPaymentsModeView:
            return () => import("../../containers/AppPage/Purchases/Payments/new");
        case AppRoute.PurchasesPaymentsView:
            return () => import("../../containers/AppPage/Purchases/Payments/view");
        case AppRoute.PurchasesRefunds:
            return () => import("../../containers/AppPage/Purchases/Refunds");
        case AppRoute.PurchasesRefundsNew:
            return () => import("../../containers/AppPage/Purchases/Refunds/new");
        case AppRoute.PurchasesRefundsView:
            return () => import("../../containers/AppPage/Purchases/Refunds/view");
        case AppRoute.PurchasesOpeningBillsView:
            return () => import("../../containers/AppPage/Purchases/OpeningBills/view");
        case AppRoute.PurchasesOpeningCreditNotesView:
            return () => import("../../containers/AppPage/Purchases/OpeningCreditNotes/view");
        case AppRoute.Shoebox:
            return () => import("../../containers/AppPage/Shoebox");
        case AppRoute.Bank:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.BankIncomes:
            return () => import("../../containers/AppPage/Bank/Incomes");
        case AppRoute.BankIncomesNew:
            return () => import("../../containers/AppPage/Bank/Incomes/new");
        case AppRoute.BankIncomesBatch:
            return () => import("../../containers/AppPage/Bank/Incomes/BatchIncomes");
        case AppRoute.BankIncomesView:
            return () => import("../../containers/AppPage/Bank/Incomes/view");
        case AppRoute.BankExpenses:
            return () => import("../../containers/AppPage/Bank/Expenses");
        case AppRoute.BankExpensesNew:
            return () => import("../../containers/AppPage/Bank/Expenses/new");
        case AppRoute.BankExpensesBatch:
            return () => import("../../containers/AppPage/Bank/Expenses/BatchExpenses");
        case AppRoute.BankExpensesView:
            return () => import("../../containers/AppPage/Bank/Expenses/view");
        case AppRoute.BankTransfers:
            return () => import("../../containers/AppPage/Bank/Transfers");
        case AppRoute.BankTransfersNew:
            return () => import("../../containers/AppPage/Bank/Transfers/new");
        case AppRoute.BankTransfersView:
            return () => import("../../containers/AppPage/Bank/Transfers/view");
        case AppRoute.BankAccounts:
            return () => import("../../containers/AppPage/Bank/Accounts");
        case AppRoute.BankAccountsNew:
            return () => import("../../containers/AppPage/Bank/Accounts/new");
        case AppRoute.BankAccountsView:
            return () => import("../../containers/AppPage/Bank/Accounts/view");
        case AppRoute.BankAccountsReconcile:
            return () => import("../../containers/AppPage/Bank/Accounts/Reconciliations");
        case AppRoute.BankFeeds:
            return () => import("../../containers/AppPage/Bank/BankFeedConnect");
        case AppRoute.BankFeedTransactions:
            return () => import("../../containers/AppPage/Bank/BankFeedTransactions");
        case AppRoute.Contacts:
            return () => import("../../containers/AppPage/Contacts");
        case AppRoute.ContactsNew:
            return () => import("../../containers/AppPage/Contacts/new");
        case AppRoute.ContactsImport:
            return () => import("../../containers/AppPage/Contacts/Import");
        case AppRoute.ContactsBatchUpdate:
            return () => import("../../containers/AppPage/Contacts/BatchUpdate");
        case AppRoute.ContactsGroups:
            return () => import("../../containers/AppPage/ControlPanel/ContactGroups");
        case AppRoute.ContactsGroupsNew:
            return () => import("../../containers/AppPage/ControlPanel/ContactGroups/view");
        case AppRoute.ContactsGroupsView:
            return () => import("../../containers/AppPage/ControlPanel/ContactGroups/view");
        case AppRoute.ContactsStatement:
            return () => import("../../containers/AppPage/Contacts/Statement");
        case AppRoute.ContactsView:
            return () => import("../../containers/AppPage/Contacts/view");
        case AppRoute.ContactsViewAuditLog:
            // return () => import("../../containers/AppPage/Contacts/ContactAuditLog");
            return () => import("../../containers/AppPage/AuditLogPage");
        case AppRoute.Products:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.ProductsItems:
            return () => import("../../containers/AppPage/Products");
        case AppRoute.ProductsItemsNew:
            return () => import("../../containers/AppPage/Products/view");
        case AppRoute.ProductsItemsImport:
            return () => import("../../containers/AppPage/Products/Import");
        case AppRoute.ProductsItemsBatchUpdate:
            return () => import("../../containers/AppPage/Products/BatchUpdate");
        case AppRoute.ProductsItemsView:
            return () => import("../../containers/AppPage/Products/view");
        case AppRoute.ProductsViewAuditLog:
            // return () => import("../../containers/AppPage/Products/ProductAuditLog");
            return () => import("../../containers/AppPage/AuditLogPage");
        case AppRoute.ProductsGroups:
            return () => import("../../containers/AppPage/Products/Groups");
        case AppRoute.ProductsGroupsNew:
            return () => import("../../containers/AppPage/Products/Groups/view");
        case AppRoute.ProductsGroupsView:
            return () => import("../../containers/AppPage/Products/Groups/view");
        case AppRoute.ProductsBundlesNew:
            return () => import("../../containers/AppPage/Products/Bundles/view");
        case AppRoute.ProductsBundlesView:
            return () => import("../../containers/AppPage/Products/Bundles/view");
        case AppRoute.StockAdjustments:
            return () => import("../../containers/AppPage/StockAdjustments");
        case AppRoute.StockAdjustmentsNew:
            return () => import("../../containers/AppPage/StockAdjustments/New");
        case AppRoute.StockAdjustmentsView:
            return () => import("../../containers/AppPage/StockAdjustments/View");
        case AppRoute.StockTransfers:
            return () => import("../../containers/AppPage/StockTransfers");
        case AppRoute.StockTransfersNew:
            return () => import("../../containers/AppPage/StockTransfers/new");
        case AppRoute.StockTransfersView:
            return () => import("../../containers/AppPage/StockTransfers/view");
        case AppRoute.StockValuesView:
            return () => import("../../containers/AppPage/Stock/Values");
        case AppRoute.MyInvoisDocuments:
            return () => import("../../containers/AppPage/MyInvois/Documents");
        case AppRoute.MyInvoisDocumentsView:
            return () => import("../../containers/AppPage/MyInvois/Documents/view");
        case AppRoute.MyInvoisIncomingDocuments:
            return () => import("../../containers/AppPage/MyInvois/IncomingDocuments");
        case AppRoute.MyInvoisTransactions:
            return () => import("../../containers/AppPage/MyInvois/Transactions");
        case AppRoute.MyInvoisBukkuMiniPos:
            return () => import("../../containers/AppPage/MyInvois/BukkuMiniPos");
        case AppRoute.Reports:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.ReportsAll:
            return () => import("../../containers/AppPage/Reports");
        case AppRoute.ReportsBalanceSheet:
            return () => import("../../containers/AppPage/Reports/BalanceSheet");
        case AppRoute.ReportsProfitLoss:
            return () => import("../../containers/AppPage/Reports/ProfitLoss");
        case AppRoute.ReportsCashFlow:
            return () => import("../../containers/AppPage/Reports/Cashflow");
        case AppRoute.ReportsTrialBalance:
            return () => import("../../containers/AppPage/Reports/TrialBalance");
        case AppRoute.ReportsAgedReceivablesSummary:
            return () => import("../../containers/AppPage/Reports/AgedSummary/ARSummary");
        case AppRoute.ReportsAgedReceivablesDetail:
            return () => import("../../containers/AppPage/Reports/AgedDetail/ARDetail");
        case AppRoute.ReportsAgedPayablesSummary:
            return () => import("../../containers/AppPage/Reports/AgedSummary/APSummary");
        case AppRoute.ReportsAgedPayablesDetail:
            return () => import("../../containers/AppPage/Reports/AgedDetail/APDetail");
        case AppRoute.ReportsProductSalesSummary:
            return () => import("../../containers/AppPage/Reports/ProductSalesAndPurchases/ProductSalesSummary");
        case AppRoute.ReportsProductSalesDetail:
            return () => import("../../containers/AppPage/Reports/ProductSalesAndPurchases/ProductSalesDetail");
        case AppRoute.ReportsProductBundleSalesSummary:
            return () => import("../../containers/AppPage/Reports/ProductBundleSalesAndPurchases/ProductBundleSalesSummary");
        case AppRoute.ReportsProductPurchasesSummary:
            return () => import("../../containers/AppPage/Reports/ProductSalesAndPurchases/ProductPurchasesSummary");
        case AppRoute.ReportsProductPurchasesDetail:
            return () => import("../../containers/AppPage/Reports/ProductSalesAndPurchases/ProductPurchasesDetail");
        case AppRoute.ReportsItemSalesCollection:
            return () => import("../../containers/AppPage/Reports/ItemSalesCollection");
        case AppRoute.ReportsTagSalesSummary:
            return () => import("../../containers/AppPage/Reports/SalesSummaryByTag");
        case AppRoute.ReportsCustomerSalesSummary:
            return () => import("../../containers/AppPage/Reports/SummaryByContacts/SalesSummaryByCustomer");
        case AppRoute.ReportsGeneralLedger:
            return () => import("../../containers/AppPage/Reports/Ledger/GeneralLedger");
        case AppRoute.ReportsDebtorLedger:
            return () => import("../../containers/AppPage/Reports/Ledger/DebtorLedger");
        case AppRoute.ReportsCreditorLedger:
            return () => import("../../containers/AppPage/Reports/Ledger/CreditorLedger");
        case AppRoute.ReportsInvoiceSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/InvoiceSummary");
        case AppRoute.ReportsCreditNoteSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/CreditNoteSummary");
        case AppRoute.ReportsPurchaseCreditNoteSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/PurchaseCreditNoteSummary");
        case AppRoute.ReportsPaymentSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/PaymentSummary");
        case AppRoute.ReportsPurchasePaymentSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/PurchasePaymentSummary");
        case AppRoute.ReportsBillSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/BillSummary");
        case AppRoute.ReportsBankReconciliation:
            return () => import("../../containers/AppPage/Reports/BankReconciliation");
        case AppRoute.ReportsReconciledTransactions:
            return () => import("../../containers/AppPage/Reports/ReconciledTransactions");
        case AppRoute.ReportsInventorySummary:
            return () => import("../../containers/AppPage/Reports/Inventory/InventorySummary");
        case AppRoute.ReportsInventoryDetail:
            return () => import("../../containers/AppPage/Reports/Inventory/InventoryDetail");
        case AppRoute.ReportsInventorySummaryByLocation:
            return () => import("../../containers/AppPage/Reports/Inventory/InventorySummaryByLocation");
        case AppRoute.ReportsProfitSummary:
            return () => import("../../containers/AppPage/Reports/ProfitSummary");
        case AppRoute.ReportsProfitDetail:
            return () => import("../../containers/AppPage/Reports/ProfitDetail");
        case AppRoute.ReportsCustomerQuotations:
            return () => import("../../containers/AppPage/Reports/TransactionByContacts/Quotations");
        case AppRoute.ReportsSupplierOrders:
            return () => import("../../containers/AppPage/Reports/TransactionByContacts/PurchaseOrders");
        case AppRoute.ReportsSupplierPurchasesSummary:
            return () => import("../../containers/AppPage/Reports/SummaryByContacts/PurchasesSummaryBySupplier");
        case AppRoute.ReportsCustomerSalesOrders:
            return () => import("../../containers/AppPage/Reports/TransactionByContacts/SalesOrders");
        case AppRoute.ReportsCustomerDeliveryOrders:
            return () => import("../../containers/AppPage/Reports/TransactionByContacts/DeliveryOrders");
        case AppRoute.ReportsSst02:
            return () => import("../../containers/AppPage/Reports/Sst02");
        case AppRoute.ReportsSstSalesDetail:
            return () => import("../../containers/AppPage/Reports/SstSalesDetail");
        case AppRoute.ReportsSstPurchaseDetail:
            return () => import("../../containers/AppPage/Reports/SstPurchaseDetail");
        case AppRoute.ReportsSstPaymentCollection:
            return () => import("../../containers/AppPage/Reports/SstPaymentCollection");
        case AppRoute.ReportsSstDeemedPayments:
            return () => import("../../containers/AppPage/Reports/SstTransactions/SstDeemedPayments");
        case AppRoute.ReportsSstRecoveredPayments:
            return () => import("../../containers/AppPage/Reports/SstTransactions/SstRecoveredPayments");
        case AppRoute.ReportsFixedAssets:
            return () => import("../../containers/AppPage/Reports/FixedAssets");
        case AppRoute.ReportsSstPastPrepayments:
            return () => import("../../containers/AppPage/Reports/SstTransactions/SstPastPrepayments");
        case AppRoute.ReportsSstCurrentPrepayments:
            return () => import("../../containers/AppPage/Reports/SstTransactions/SstCurrentPrepayments");
        case AppRoute.ReportsSstByProducts:
            return () => import("../../containers/AppPage/Reports/SstTransactions/SstByProducts");
        case AppRoute.ReportsDepreciationSchedule:
            return () => import("../../containers/AppPage/Reports/DepreciationSchedule");
        case AppRoute.ReportsDisposalSchedule:
            return () => import("../../containers/AppPage/Reports/DisposalSchedule");
        case AppRoute.ReportsFinancialSummary:
            return () => import("../../containers/AppPage/Reports/FinancialSummary");
        case AppRoute.ReportsForeignExchangeSummary:
            return () => import("../../containers/AppPage/Reports/ForeignExchangeSummary");
        // case AppRoute.ReportsForeignExchangeDetail:
        //     return () => import("../../containers/AppPage/Reports/ForeignExchangeDetail");
        case AppRoute.ReportsUnrealisedExchangeDetail:
            return () => import("../../containers/AppPage/Reports/UnrealisedExchangeDetail");
        case AppRoute.ReportsExchangeRates:
            return () => import("../../containers/AppPage/Reports/ExchangeRates");
        case AppRoute.ReportsTransactionList:
            return () => import("../../containers/AppPage/Reports/TransactionList");
        case AppRoute.ReportsAuditTrails:
            return () => import("../../containers/AppPage/Reports/AuditTrails");
        case AppRoute.ReportsPaymentVoucherSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/PaymentAndReceiptSummary/PaymentVoucherSummary");
        case AppRoute.ReportsOfficialReceiptSummary:
            return () => import("../../containers/AppPage/Reports/TransactionSummary/PaymentAndReceiptSummary/OfficialReceiptSummary");
        case AppRoute.ReportsCashSalesSummary:
            return () => import("../../containers/AppPage/Reports/CashSummary/CashSalesSummary");
        case AppRoute.ReportsCashPurchaseSummary:
            return () => import("../../containers/AppPage/Reports/CashSummary/CashPurchaseSummary");
        case AppRoute.ReportsJournalEntryDetail:
            return () => import("../../containers/AppPage/Reports/JournalEntryDetail");
        case AppRoute.ReportsDoubleEntryDetail:
            return () => import("../../containers/AppPage/Reports/DoubleEntryDetail");
        case AppRoute.ReportsChartOfAccounts:
            return () => import("../../containers/AppPage/Reports/ChartOfAccounts");
        case AppRoute.Accounting:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.AccountingJournalEntries:
            return () => import("../../containers/AppPage/Accounting/JournalEntries");
        case AppRoute.AccountingJournalEntriesNew:
            return () => import("../../containers/AppPage/Accounting/JournalEntries/new");
        case AppRoute.AccountingJournalEntriesBatch:
            return () => import("../../containers/AppPage/Accounting/JournalEntries/BatchJournalEntry");
        case AppRoute.AccountingJournalEntriesPayroll:
            return () => import("../../containers/AppPage/Accounting/JournalEntries/Payroll");
        case AppRoute.AccountingJournalEntriesView:
            return () => import("../../containers/AppPage/Accounting/JournalEntries/view");
        case AppRoute.AccountingContras:
            return () => import("../../containers/AppPage/Accounting/Contras");
        case AppRoute.AccountingContrasNew:
            return () => import("../../containers/AppPage/Accounting/Contras/new");
        case AppRoute.AccountingContrasView:
            return () => import("../../containers/AppPage/Accounting/Contras/view");
        case AppRoute.AccountingAccounts:
            return () => import("../../containers/AppPage/Accounting/Accounts");
        case AppRoute.AccountingAccountsNew:
            return () => import("../../containers/AppPage/Accounting/Accounts/new");
        case AppRoute.AccountingAccountsImport:
            return () => import("../../containers/AppPage/Accounting/Accounts/Import");
        case AppRoute.AccountingAccountsOpeningBalance:
            return () => import("../../containers/AppPage/Accounting/Accounts/OpeningBalance");
        case AppRoute.AccountingAccountsView:
            return () => import("../../containers/AppPage/Accounting/Accounts/view");
        case AppRoute.AccountingAccountsViewAuditLog:
            return () => import("../../containers/AppPage/AuditLogPage");
        case AppRoute.AccountingDeemedPayments:
            return () => import("../../containers/AppPage/Accounting/DeemedPayments");
        case AppRoute.AccountingDeemedPaymentsNew:
            return () => import("../../containers/AppPage/Accounting/DeemedPayments/new");
        case AppRoute.AccountingDeemedPaymentsView:
            return () => import("../../containers/AppPage/Accounting/DeemedPayments/view");
        case AppRoute.AccountingAssets:
            return () => import("../../containers/AppPage/Assets");
        case AppRoute.AccountingAssetsDepreciate:
            return () => import("../../containers/AppPage/Assets/Depreciate");
        case AppRoute.AccountingAssetsNew:
            return () => import("../../containers/AppPage/Assets/New");
        case AppRoute.AccountingAssetsBatch:
            return () => import("../../containers/AppPage/Assets/BatchRegister");
        case AppRoute.AccountingAssetsView:
            return () => import("../../containers/AppPage/Assets/View");
        case AppRoute.AccountingAssetsEdit:
            return () => import("../../containers/AppPage/Assets/Edit");
        case AppRoute.AccountingAssetsDispose:
            return () => import("../../containers/AppPage/Assets/Dispose");
        case AppRoute.ControlPanel:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.Instructions:
            return () => import("../../containers/AppPage/ControlPanel/Instructions");
        case AppRoute.InstructionsNew:
            return () => import("../../containers/AppPage/ControlPanel/Instructions/new");
        case AppRoute.InstructionsView:
            return () => import("../../containers/AppPage/ControlPanel/Instructions/view");
        case AppRoute.FileManager:
            return () => import("../../containers/AppPage/ControlPanel/FileManager");
        case AppRoute.Terms:
            return () => import("../../containers/AppPage/ControlPanel/Terms");
        case AppRoute.TermsNew:
            return () => import("../../containers/AppPage/ControlPanel/Terms/new");
        case AppRoute.TermsView:
            return () => import("../../containers/AppPage/ControlPanel/Terms/view");
        case AppRoute.Currencies:
            return () => import("../../containers/AppPage/ControlPanel/Currencies");
        case AppRoute.CurrenciesCode:
            return () => import("../../containers/AppPage/ControlPanel/Currencies/view");
        case AppRoute.Tags:
            return () => import("../../containers/AppPage/ControlPanel/Tags");
        case AppRoute.AssetTypes:
            return () => import("../../containers/AppPage/Assets/Types");
        case AppRoute.AssetTypesNew:
            return () => import("../../containers/AppPage/Assets/Types/new");
        case AppRoute.AssetTypesView:
            return () => import("../../containers/AppPage/Assets/Types/view");
        case AppRoute.Locations:
            return () => import("../../containers/AppPage/Locations");
        case AppRoute.LocationsNew:
            return () => import("../../containers/AppPage/Locations/new");
        case AppRoute.LocationsView:
            return () => import("../../containers/AppPage/Locations/view");
        case AppRoute.Fields:
            return () => import("../../containers/AppPage/ControlPanel/Fields");
        case AppRoute.FieldsNew:
            return () => import("../../containers/AppPage/ControlPanel/Fields/new");
        case AppRoute.FieldsView:
            return () => import("../../containers/AppPage/ControlPanel/Fields/view");
        case AppRoute.PriceLevels:
            return () => import("../../containers/AppPage/ControlPanel/PriceLevels");
        case AppRoute.PaymentMethods:
            return () => import("../../containers/AppPage/ControlPanel/PaymentMethods");
        case AppRoute.FormDesigns:
            return () => import("../../containers/AppPage/ControlPanel/FormDesigns");
        case AppRoute.FormDesignsNew:
            return () => import("../../containers/AppPage/ControlPanel/FormDesigns/view");
        case AppRoute.FormDesignsView:
            return () => import("../../containers/AppPage/ControlPanel/FormDesigns/view");
        case AppRoute.Profile:
            return () => import("../../containers/AppPage/ControlPanel/Profile");
        case AppRoute.Settings:
            return () => import("../../containers/AppPage/ControlPanel/Settings");
        case AppRoute.Flow:
            return () => import("../../containers/AppPage/ControlPanel/Flow");
        case AppRoute.FlowStreamSettingsView:
            return () => import("../../containers/AppPage/ControlPanel/Flow/Stream/StreamSettings");
        case AppRoute.FlowStreamMappingsView:
            return () => import("../../containers/AppPage/ControlPanel/Flow/Stream/StreamMappings");
        case AppRoute.FlowDigests:
            return () => import("../../containers/AppPage/Flow/Digests");
        case AppRoute.FlowDigestsView:
            return () => import("../../containers/AppPage/Flow/Digests/DigestView");
        case AppRoute.NumberFormats:
            return () => import("../../containers/AppPage/NumberFormats");
        case AppRoute.ShoeboxSettings:
            return () => import("../../containers/AppPage/ControlPanel/Shoebox");
        case AppRoute.Subscription:
            return () => import("../../containers/AppPage/ControlPanel/Subscription");
        case AppRoute.Integrations:
            return () => import("../../containers/AppPage/Integrations");
        case AppRoute.BackupData:
            return () => import("../../containers/AppPage/ControlPanel/Backup");
        case AppRoute.Users:
            return () => import("../../containers/AppPage/ControlPanel/Users");
        case AppRoute.UsersNew:
            return () => import("../../containers/AppPage/ControlPanel/Users/view");
        case AppRoute.UsersView:
            return () => import("../../containers/AppPage/ControlPanel/Users/view");
        case AppRoute.Apps:
            return () => import("../../containers/AppPage/ControlPanel/Apps");
        case AppRoute.Store:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.StoreOrders:
            return () => import("../../containers/AppPage/StoreSettings/Orders");
        case AppRoute.StoreCategories:
            return () => import("../../containers/AppPage/StoreSettings/Categories");
        case AppRoute.StoreCategoriesNew:
            return () => import("../../containers/AppPage/StoreSettings/Categories/view");
        case AppRoute.StoreCategoriesRearrange:
            return () => import("../../containers/AppPage/StoreSettings/Categories/rearrange");
        case AppRoute.StoreCategoriesView:
            return () => import("../../containers/AppPage/StoreSettings/Categories/view");
        case AppRoute.StorePages:
            return () => import("../../containers/AppPage/StoreSettings/Pages");
        case AppRoute.StorePagesNew:
        case AppRoute.StorePagesView:
            return () => import("../../containers/AppPage/StoreSettings/Pages/view");
        case AppRoute.StoreCoupons:
            return () => import("../../containers/AppPage/StoreSettings/Coupons");
        case AppRoute.StoreCouponsNew:
        case AppRoute.StoreCouponsView:
            return () => import("../../containers/AppPage/StoreSettings/Coupons/view");
        case AppRoute.StoreSettings:
            return () => import("../../containers/AppPage/StoreSettings/Settings");
        case AppRoute.MiniPos:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.MiniPosSettings:
            return () => import("../../containers/AppPage/MiniPos/Settings");
        case AppRoute.MiniPosOrders:
            return () => import("../../containers/AppPage/MiniPos/Orders");
        case AppRoute.MiniPosOrdersView:
            return () => import("../../containers/AppPage/MiniPos/Orders/view");
        case AppRoute.Partners:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
        case AppRoute.PartnersProfile:
            return () => import("../../containers/AppPage/Partners/Profile");
        case AppRoute.PartnersClients:
            return () => import("../../containers/AppPage/Partners/Clients");
        case AppRoute.PartnersClientsClientUsers:
            return () => import("../../containers/AppPage/ControlPanel/Users");
        case AppRoute.PartnersClientsClientUsersNew:
            return () => import("../../containers/AppPage/ControlPanel/Users/view");
        case AppRoute.PartnersClientsClientUsersView:
            return () => import("../../containers/AppPage/ControlPanel/Users/view");
        case AppRoute.PartnersClientsReferrals:
            return () => import("../../containers/AppPage/Partners/Referrals");
        case AppRoute.PartnersTransactions:
            return () => import("../../containers/AppPage/Partners/Transactions");
        case AppRoute.PartnersEventLogs:
            return () => import("../../containers/AppPage/Partners/Logs");
        case AppRoute.PartnersAdvisors:
            return () => import("../../containers/AppPage/Partners/Advisors");
        case AppRoute.PartnersAdvisorsNew:
            return () => import("../../containers/AppPage/Partners/Advisors/view");
        case AppRoute.PartnersAdvisorsView:
            return () => import("../../containers/AppPage/Partners/Advisors/view");
        case AppRoute.PartnersBrandAssets:
            return () => import("../../containers/AppPage/Partners/BrandAssets");
        case AppRoute.ImportUbs:
            return () => import("../../containers/AppPage/Import/Ubs");
        case AppRoute.Annotate:
            return () => import("../../containers/AppPage/Annotate");
        case AppRoute.TestDnd:
            return () => import("../../containers/AppPage/Test/DragNDrop");
        case AppRoute.TestTodo:
            return () => import("../../containers/AppPage/Test/Todo");
        case AppRoute.TestLightgallery2:
            return () => import("../../containers/AppPage/Test/LightGallery/index2");
        case AppRoute.TestLightgallery3:
            return () => import("../../containers/AppPage/Test/LightGallery/index3");
        case AppRoute.TestLightgallery4:
            return () => import("../../containers/AppPage/Test/LightGallery/index4");
        case AppRoute.TestLightgallery5:
            return () => import("../../containers/AppPage/Test/LightGallery/index5Redux");
        case AppRoute.TestLightgallery51:
            return () => import("../../containers/AppPage/Test/LightGallery/index5ReduxDestroyed");
        case AppRoute.TestLightgalleryPreview:
            return () => import("../../containers/AppPage/Test/LightGalleryPreview");
        case AppRoute.TestFloatingWindow:
            return () => import("../../containers/AppPage/Test/FloatingWindowPage");
        case AppRoute.TestTransitionGroup:
            return () => import("../../containers/AppPage/Test/TransitionGroup");
        case AppRoute.TestPreviewInvoice:
            return () => import("../../containers/AppPage/Test/BillingPreviewInvoice");
        case AppRoute.BukkuZoomPanel:
            return () => import("../../containers/AppPage/Test/ZoomPanel/index");
        case AppRoute.BukkuAdmin:
            return () => import("../../containers/AppPage/BukkuAdmin");
        default:
            return () => import("../../containers/App/DeniedPage/EmptyPage");
    }
}

const routes = addRouteComponent(AppRouteInfo, getAppComponent, getWrapper);

export default function AppRouter() {
    return (
        <Switch>
            { Routes(routes, "/") }
        </Switch>
    );
}
